<template>
	<div>
		<div class="actDiv">
			<label>选择任务类型</label>
			<a-select  style="width:15rem; margin: 0 0.625rem;" v-model="taskType" allowClear>
				<a-select-option v-for="(item,index) in taskTypeList" :key="item.value" :value="item.value">{{item.name}}</a-select-option>
			</a-select>
			<a-button type="primary" icon="search" @click="queryDataList">搜索</a-button>
			<a-button type="primary" icon="redo" @click="queryDataList" style=" margin: 0 0.625rem;">刷新</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  
					    rowKey="id" :pagination="false" :scroll="{y:500}"
						@expand="expandRowHandler" :expandedRowKeys="expandedRowKeys">
			<span slot="taskTypeSlot" slot-scope="text, record">
				{{getTaskType(record.taskType)}}
			</span>
			<span slot="taskResultSlot" slot-scope="text, record">
				{{getTaskResult(record.taskResult)}}
			</span>
			<span slot="taskStateSlot" slot-scope="text, record">
				{{getTaskState(record.taskState)}}
			</span>
			<span slot="theAction" slot-scope="text, record">
				<a-popconfirm title="确定要结束抄表任务吗?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="stopTask(record)">
					<a-button size="small" type="link" v-if="record.taskState==0" >结束抄表</a-button>
				</a-popconfirm>
			</span>	
			<a-table size="small" slot="expandedRowRender" slot-scope="text" :columns="innerColumns"  :data-source="readMeterLogList" 
						:pagination="false" rowKey="id" :scroll="{y:500}">
				<span slot="readTimeSlot" slot-scope="text, record">
					{{getTimeFormatter(record.create_time)}}
				</span>
			</a-table>
		</a-table>
	</div>
</template>

<script>
	const columns = [
		{
			title: '任务ID',
			dataIndex: 'id',
			width:100,
		},
		{
			title: '任务类型',
			dataIndex: 'taskType',
			width:150,
			scopedSlots: { customRender: 'taskTypeSlot' },
		},
		{
			title: '小区',
			dataIndex: 'neighborName',
			width:240,
		},
		{
			title: '目标对象',
			dataIndex: 'taskObject',
			width:240,
		},
		{
			title: '任务状态',
			dataIndex: 'taskState',
			width:110,
			scopedSlots: { customRender: 'taskStateSlot' },
		},
		{
			title: '任务结果',
			width:130,
			dataIndex: 'taskResult',
			scopedSlots: { customRender: 'taskResultSlot' },
		},
		{
			title: '创建时间',
			dataIndex: 'createTime',
			width:150,
		},
		{
			title: '操作',
			dataIndex: 'pId',
			width:100,
			scopedSlots: { customRender: 'theAction' },
			align:'center',
		},	
	];
	const innerColumns = [
		{
			title: '表地址',
			dataIndex: 'MeterAddr',
			width:120,
		},
		{
			title: '本次抄表结果',
			dataIndex: 'result_data',
			width:120,
		},
		{
			title: '抄表详情',
			dataIndex: 'result_desc',
			width:150,
		},
		{
			title: '结束时间',
			dataIndex: 'create_time',
			width:160,
			scopedSlots: { customRender: 'readTimeSlot' },
		}
	];
	export default{
		data(){
			return {
				columns,
				innerColumns,
				taskType:null,
				list:[],
				loading:true,
				expandedRowKeys:[],
				theObj:{},
				readMeterLogList:[],
			}
		},
		methods:{
			stopTask:function(record){
				let url = this.Api.getLastUrl(this.Api.STOP_METER_TASK_DETAIL_URL);
				let param = {taskId:record.id};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("成功结束抄表任务！");
						this.queryDataList();
					}else{
						this.$message.error(msg);
					}
				}).catch((data)=>{
					this.loading = false;
					console.log(error);
				});
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.READ_METER_TASK_DETAIL_URL);
				let param = {taskType:this.taskType};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((data)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getTaskType:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getReadMeterTaskTypeList());
			},
			getTaskResult:function(result){
				if (result == null || result.length == 0){
					return '正常';
				}else{
					return result;
				}
			},
			expandRowHandler:function(expand,record){
				this.expandedRowKeys.pop();
				if(expand){
					this.expandedRowKeys.push(record.id);
					this.theObj = record;
					this.queryReadMeterLogList();
				}
			},
			queryReadMeterLogList:function(){
				let url = this.Api.getLastUrl(this.Api.READ_METER_TASKDETAIL_LIST_URL);
				let param = {taskId:this.theObj.id};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.readMeterLogList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
			getTaskState:function(state){
				var result = null;
				switch(state){
					case "0":
						result="处理中";
					break
					
					case "1":
						result="正常结束";
					break;
					case "2":
						result="非正常结束";
					break;
					default:
						result = "结束";
					break;
				}
				return result;
			},
		},
		created() {
			this.queryDataList();
		},
		computed:{
			taskTypeList:function(){
				return this.Config.getReadMeterTaskTypeList();
			}
		}
	}
</script>

<style>
</style>
